import React, { lazy } from 'react';
import { FileTextOutlined } from '@ant-design/icons';
import { ProtectedRoute } from '@components';

const InternalContractPage = lazy(() => import('./page'));

export default {
  path: 'internalContract',
  element: <ProtectedRoute title="内部合同" allowAccess component={<InternalContractPage />} />,
  options: {
    title: '内部合同',
    key: 'internalContract',
    icon: <FileTextOutlined />,
    link: '/internalContract',
  },
};
